import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { ToastAction, ToastConfig } from './toast.types';

export const TOAST_CLOSE_DELAY_AFTER_HOVER = 4000;

@Component({
  selector: 'twaice-fe-toast',
  templateUrl: './toast.component.html',
  imports: [SvgIconModule],
})
export class ToastComponent implements OnInit, OnDestroy {
  @Input({ required: true }) config!: ToastConfig;
  @Output() dismissed = new EventEmitter<void>();

  private closeTimer: ReturnType<typeof setTimeout> | null = null;

  ngOnInit(): void {
    this.scheduleClose(this.config.duration);
  }

  ngOnDestroy(): void {
    this.cancelClose();
  }

  pause(): void {
    this.cancelClose();
  }

  resume(): void {
    this.scheduleClose(this.config.duration === null ? null : TOAST_CLOSE_DELAY_AFTER_HOVER);
  }

  runAction(action: ToastAction): void {
    action.onClick();
    this.close();
  }

  close(): void {
    this.cancelClose();
    this.dismissed.emit();
  }

  private scheduleClose(delay: number | null): void {
    this.cancelClose();
    if (delay !== null) {
      this.closeTimer = setTimeout(() => this.close(), delay);
    }
  }

  private cancelClose(): void {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
  }
}
